
import appAjax from './ajax';
import $ from 'jquery';

export default {
    initGeoLocation(onSuccess) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(onSuccess, this.onGeoLocationError);
        } else {
            this.alertMessage("Geolocation is not supported by this browser.");
        }
    },

    onGeoLocationError(error) {
        console.log(error);
        if (error.code === error.PERMISSION_DENIED) {
            appAjax.alertMessage("User denied the request for Geolocation.");
            return;
        } else if (error.code === error.POSITION_UNAVAILABLE) {
            appAjax.alertMessage("Location information is unavailable.");
            return;
        } else if (error.code === error.TIMEOUT) {
            appAjax.alertMessage("The request to get user location timed out.");
            return;
        } else if (error.code === error.UNKNOWN_ERROR) {
            appAjax.alertMessage("An unknown error occurred.");
            return;
        }
    },

    onGeoLocationSuccess(position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        // appAjax.addBubble("Location: " + lat + ", " + lng);

        appAjax.currentGeoLocation = {lat: lat, lng: lng};
        $('.val_pos_lat').val(lat);
        $('.val_pos_lng').val(lng);

        appAjax._ajax_send({
            lat: parseFloat(lat), lng: parseFloat(lng)
        }, {
            type: 'POST',
            success: function(response) {
                $('.show_if_gpsexist').show();
            },
            error: function(response) {
                appAjax.alertMessage("Error: " + response.message);
            }
        }, 'Saving...', appAjax.utilBaseUrl+'/?p=api&act=save_location');
    }
};
